import { useQuery } from '@apollo/client';
import React from 'react';
import Form from '../components/Form';
import SearchInput from '../components/SearchInput';
import useSlug from '../utils/router/useSlug';
import { publicTopicPath } from '../utils/url/topicPath';
import { useRouter } from '../utils/router/v3Bridge';
import { gql } from '../graphql/generated/gql';

const EXTERNAL_SEARCH_INPUT_PUBLIC_POST_QUERY = gql(`
  query ExternalSearchInputPublicPost($id: ID!) {
    post: publicPost(id: $id) {
      id
      topics {
        id
        ancestors {
          id
          ancestors {
            id
          }
          ...publicTopicPath_topic
        }
        ...publicTopicPath_topic
      }
    }
  }
`);

interface ExternalSearchInputProps {
  autoFocus: boolean;
}

const ExternalSearchInput = ({ autoFocus }: ExternalSearchInputProps) => {
  const [id] = useSlug('postSlug');
  const { data: { post } = {} } = useQuery(
    EXTERNAL_SEARCH_INPUT_PUBLIC_POST_QUERY,
    {
      variables: { id },
    },
  );

  const firstTopic = post?.topics[0];
  const highestPublicAncestorTopic =
    firstTopic?.ancestors.find((topic) => topic.ancestors.length === 0) ??
    firstTopic;

  const router = useRouter();

  if (highestPublicAncestorTopic == null) return null;

  return (
    <Form<{ query: string }>
      initialValues={{ query: '' }}
      onSubmit={({ query }) => {
        if (highestPublicAncestorTopic) {
          router.push({
            pathname: publicTopicPath(highestPublicAncestorTopic),
            search: `?search=${query}`,
          });
        }
      }}
    >
      {(props) => (
        <SearchInput
          onChange={(e) => props.setValues({ query: e.target.value })}
          value={props.values.query}
          placeholder="Search for knowledge..."
          autoFocus={autoFocus}
        />
      )}
    </Form>
  );
};

export default ExternalSearchInput;
